export class UuidHelperService {

  public static generateUuid(): string {
    return '' + self.crypto.randomUUID();
  }

}
